/**
 * Background component sets the background of the scene
 * 
 * @param {*} param0 
 * @returns 
 */
const Background = ({color}) => { return <color attach="background" args={[color]} /> }

export default Background;